import * as generalTypes from "../types/general";

const initStore = {
  loading: false,
};

export default (state = initStore, action) => {
  switch (action.type) {
    case generalTypes.SHOW_LOADING:
      return { ...state, loading: true };
    case generalTypes.HIDE_LOADING:
      return { ...state, loading: false };
    default:
      return state;
  }
};
